import moment from 'external/moment'
import { useEffect } from 'external/react'
import {styled, Calendar, Box} from "external/material"
import useTranslations from "hooks/translations"


import useStudent from 'hooks/student'


const StyledSidebarCalendar = styled(Box)(sidebarCalendarStyles)

export default function DashboardSidebarCalendar(props) {

    const {language} = useTranslations()
  
    const {date, eventsByDay} = useStudent()
  
    const calendarValue = date().toDate()

    const activeClass = (day) => {
      const events = eventsByDay[moment(day.date).format('YYYY-MM-DD')] || []
      const isActive = events.length > 0
      return isActive ? 'scheduled-day' : 'empty'
    }
    
    useEffect(() => {
        if (language) {
            moment.locale(language)
        }
    }, [language])


    return (
        <StyledSidebarCalendar>
            <Calendar
              activeStartDate={calendarValue}
              onActiveStartDateChange={props.onCalendarChange}
              formatMonth = {(_, date) => moment(date).format('MMMM')}
              formatMonthYear= {(_, date) => moment(date).format('MMMM YYYY')}
              formatShortWeekday={(_, date) => moment(date).format('dd')}
              tileClassName={activeClass}
              minDetail="month"
              showNeighboringMonth={false}
              onClickDay= {day => {
                const isActive = activeClass({date: day}) != 'empty'
                if (isActive) {
                  props.navigation.scheduleView.goWithQuery({
                    fromDashboard: true,
                    start:  moment(day).startOf('day').format('YYYY-MM-DD'),
                    end: moment(day).endOf('day').format('YYYY-MM-DD')
                  }, false, {scheduleView: 'day'})
                }
              }}
            />
        </StyledSidebarCalendar>
    )
}

function sidebarCalendarStyles() {

    const tile = {
      marginTop: -5,
      lineHeight: '12px',
      display: 'flex',
      justifyContent: 'center',
      padding: '6px 3px',
      "& abbr": {
        color: "#877272c7",
        paddingTop: 4,
        paddingBottom: 4,
        flexGrow: 1,
      }

    }

    return {
        height: 228,
        "& .react-calendar": {
            border: "none",
            padding: "0 8px"
        },
        "& .react-calendar__month-view__weekdays": {
            padding: 0
        },
        "& .react-calendar__navigation": {
            height: 35,
            marginBottom: 0,

            "& button": {
                backgroundColor: '#fff !important',

                "&.react-calendar__navigation__arrow": {
                    fontSize: '10.5pt',
                },
                "&.react-calendar__navigation__label": {
                    paddingTop: 4,
                    color: '#434a5d',
                    fontSize: '10.5pt',
                },
                "&:enabled:hover": {
                    color: '#000',
                    backgroundColor: '#fff !important'
                }
            }
        },
        "& .react-calendar__tile": tile,
        "& .react-calendar__tile.empty": {
            cursor: 'default !important',
            borderRadius: "5px !important",
            backgroundColor: "#fff !important",
            "& abbr": {
                color: "#877272c7"
            }

        },
        "& .react-calendar__tile.react-calendar__tile--now": {
            "& abbr": {
                borderRadius: "50px !important",
                backgroundColor: '#ff9b00 !important',
                color: '#000'
            }
        },
        "& .react-calendar__tile.scheduled-day": {
            backgroundColor: "#fff !important",
            "& abbr": {
                borderRadius: "50px !important",
                backgroundColor: "#669fd6",
                color: "#fff"
            },
            '&.react-calendar__tile--now': {
                "& abbr": {
                    backgroundColor: '#ff9b00',
                }
            }
        },
        "& .react-calendar__tile:enabled:hover": {
            backgroundColor: '#e6e6e6',
            borderRadius: '5px !important'
        },
    }
}
